import React from "react"

import Layout from "../components/Layout"
import Page from "../components/Layout/page"

const FairDinkumSheds = props => (
  <Layout location={props.location}>
    <Page id="6" />
  </Layout>
)

export default FairDinkumSheds
